import { useMutation } from "@tanstack/react-query";
import { vaultApi } from "../../../api/vault.api";
import { vaultKeys } from "../queryKeys";

export function useVerifyIdentity() {
  return useMutation({
    mutationKey: vaultKeys.identityVerification(),
    mutationFn: (formData: FormData) => vaultApi.verifyIdentity(formData),
    gcTime: 30 * 60 * 1000,
  });
}
